// extracted by mini-css-extract-plugin
export default {"awardRecord":"awardRecord_awardRecord__CzUSg","title":"awardRecord_title__H61nn"};